import React from "react";

interface IconIProps {
  width?: number;
  height?: number;
  fill?: string;
  size?: string;
}

const EditIcon = ({ size = "16" }: IconIProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99996 3.99996L12 5.99996M8.66663 13.3333H14M3.33329 10.6666L2.66663 13.3333L5.33329 12.6666L13.0573 4.94263C13.3073 4.69259 13.4477 4.35351 13.4477 3.99996C13.4477 3.64641 13.3073 3.30733 13.0573 3.05729L12.9426 2.94263C12.6926 2.69267 12.3535 2.55225 12 2.55225C11.6464 2.55225 11.3073 2.69267 11.0573 2.94263L3.33329 10.6666Z"
        stroke="#495A64"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default EditIcon;
